import { useLanguage } from "contexts/LocalizationContext/hooks";
import getPageUrl from "utils/getPageUrl";
import { trackEvents } from "utils/trackingUtils";
import { TOP_BANNER_CHECK_COMPENSATION_GTM, TOP_BANNER_CHECK_COMPENSATION_MP } from "modules/common/trackingConsts";
import PropTypes from "prop-types";
import { Chakra } from "@airhelp/react-ui-components";

const { Box, Link, Flex, Text } = Chakra;

const TopBanner = ({ bannerText, buttonText }) => {
  const language = useLanguage();

  return (
    <Box bg="primary.500" color="white" py={2} px={2} width="100%" boxShadow="10px -8px 24px rgba(123, 150, 176, 0.2)">
      <Flex
        mx="auto"
        justifyContent="center"
        alignItems="center"
        maxWidth="1202px"
        lineHeight={5}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Text
          display="block"
          textAlign="center"
          fontSize="s"
          fontWeight="bold"
          data-testid="top-airline-strike-bar"
          whiteSpace="pre-wrap"
        >
          {bannerText}
        </Text>
        <Link
          display="inline"
          color="white"
          _hover={{ color: "primary.200" }}
          fontWeight="bold"
          href={getPageUrl(language, "webappNewClaim")}
          textDecoration="underline"
          onClick={() =>
            trackEvents({
              gtmEvent: TOP_BANNER_CHECK_COMPENSATION_GTM,
              mixpanelEvent: TOP_BANNER_CHECK_COMPENSATION_MP,
            })
          }
          title={buttonText}
          ml={2}
        >
          {buttonText}
        </Link>
      </Flex>
    </Box>
  );
};

export default TopBanner;

TopBanner.propTypes = {
  bannerText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};
